@if (_isUserInfoLoading) {
  <ddc-loading-skeleton></ddc-loading-skeleton>
} @else {
  <form class="profile-form" [formGroup]="profileForm" (ngSubmit)="onSubmit()">
    <div class="alert alert-success success-msg" *ngIf="!_isUpdateLoading && _isUpdated">
      <div>
        <ng-lottie width="30px" [options]="options"></ng-lottie>
      </div>
      <div>&nbsp;&nbsp;&nbsp;"{{ _message }}"</div>
    </div>
    <div class="image-wrapper">
      <img class="profile-picture" [src]="_userProfilePic" />
    </div>
    <div class="form-group">
      <mat-form-field appearance="fill">
        <mat-label>Country</mat-label>
        <input id="country" formControlName="country" matInput placeholder="Enter your country" />
        <mat-hint>Enter your country</mat-hint>
        <mat-error *ngIf="profileForm.get('country').invalid">{{ getCountryErrorMessage() }}</mat-error>
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field appearance="fill">
        <mat-label>City</mat-label>
        <input id="city" formControlName="city" matInput placeholder="Enter your city" />
        <mat-hint>Enter your city</mat-hint>
        <mat-error *ngIf="profileForm.get('city').invalid">{{ getCityErrorMessage() }}</mat-error>
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field appearance="fill">
        <mat-label>Bio</mat-label>
        <textarea id="bio" formControlName="bio" matInput placeholder="Enter your bio" rows="4"></textarea>
        <mat-hint>Tell us a little about yourself</mat-hint>
        <mat-error *ngIf="profileForm.get('bio').invalid">{{ getBioErrorMessage() }}</mat-error>
      </mat-form-field>
    </div>
    <ddc-elem-chooser-one
      class="fav-language-picker form-group"
      *ngIf="_loadedFavLanguages"
      [_allElems]="_languages"
      [_defaultElems]="_selectedLanguagesLabels"
      [_elemType]="'tag'"
      [_label]="'Favorite Languages'"
      [_labelIcon]="'language'"
      [_placeholder]="'Select tags...'"
      [_type]="'fav-languages'"
      (selectedElemsChange)="updateSelectedLanguages($event)"
    ></ddc-elem-chooser-one>
    <ddc-button-s-one type="button" [_isLoading]="_isUpdateLoading" [_label]="'Update Profile'"></ddc-button-s-one>
  </form>
}
